module.exports = __webpack_public_path__ + "img/foto31.49270b35.jpg";